import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  staffDetails,
  StaffUpdates,
  VerifyStaffId,
  workingSchedulesList,
  getAvailableStaffMenus,
} from "../../api/Staff";
import { subjectList } from "../../api/Subjects";
import { LoadingDiv, SweetAlertShow, ToastMain } from "../master/Master";
import { DistrictFetch, StateFetch } from "../../api/LocationService";
import { RoleView } from "../../api/UserRoleServices";
import StaffLayout from "./StaffLayout";
import { appRoleList } from "../../api/Role";

export default function StaffUpdate() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [subjectIds, setSubjectIds] = useState("");
  const [staff_id, setStaffId] = useState("");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [error, setError] = useState("");
  const [roles, setRoles] = useState([]);
  const [salaryType, setSalaryType] = useState("");
  const [regi, setReg] = useState("");
  const [regDetail, setRegDetail] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [staffType, setStaffType] = useState("");
  const [modalData, setModalData] = useState("");
  const [workingSchedules, setWorkingSchedules] = useState([]);
  const [workingScheduleId, setWorkingScheduleId] = useState("");
  const [totalHoursPerDay, setTotalHoursPerDay] = useState("");
  const [carryForward, setCarryForward] = useState("");
  const emp = data?.employment_histories?.[0] || {};

  const [appRoles, setAppRoles] = useState([]);
  const [selectedAppRoles, setSelectedAppRoles] = useState([]);

  const [availableMenuGroups, setAvailableMenuGroups] = useState([]);
  const [requiredMenuRoutes, setRequiredMenuRoutes] = useState([]);
  const [selectedMenuRoutes, setSelectedMenuRoutes] = useState([]);

  const [setting, setSetting] = useState({});
  const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
  const isSuperAdmin = userData?.role_id == 1;

  const handleAppRoleChange = (value) => {
    value = Number(value);
    setSelectedAppRoles((prev) =>
      prev.includes(value)
        ? prev.filter((id) => id !== value)
        : [...prev, value],
    );
  };

  const getAppRoles = async () => {
    setLoading(true);

    try {
      const response = await appRoleList("");

      if (response?.data?.status) {
        setAppRoles(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.employment_histories?.length > 0) {
      const emp = data.employment_histories[0];

      setSalaryType(emp.salary_type || "");
      setCarryForward(emp.carry_forward || "");
      setTotalHoursPerDay(emp.total_hours_per_day || "");

      setModalData({
        working_schedule_id: emp.working_schedule_id || "",
      });

      // 👇 Working Days भी set करो
      if (emp?.working_schedule?.working_days) {
        try {
          const days = JSON.parse(emp.working_schedule.working_days);

          setWorkingDays(days);
        } catch {
          setWorkingDays([]);
        }
      }
    }
  }, [data]);

  // FIX: staffType must be derived from `data` once it loads (data starts
  // as "" on mount, so the old useState(data?.staff_type) initializer never
  // saw the real value). This is what was hiding the Subjects section and
  // its pre-checked values on page load for Teaching staff.
  useEffect(() => {
    if (data?.staff_type) {
      setStaffType(data.staff_type);
    }
  }, [data]);

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);

  const handleSubjectChange = (value) => {
    value = Number(value);

    setSelectedSubjects(
      (prev) =>
        prev.includes(value)
          ? prev.filter((id) => id !== value) // uncheck
          : [...prev, value], // check
    );
  };

  const getWorkingSchedule = async () => {
    setLoading(true);
    try {
      const response = await workingSchedulesList("");

      if (response?.data?.status) {
        setWorkingSchedules(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWorkingSchedule();
  }, []);

  const getUserRoles = async () => {
    setLoading(true);
    try {
      const response = await RoleView();
      if (response?.data.status) {
        setRoles(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const selectedSchedule = workingSchedules?.find(
    (s) => s.id == workingScheduleId,
  );

  useEffect(() => {
    if (salaryType === "Monthly" && selectedSchedule) {
      setTotalHoursPerDay(selectedSchedule.total_hours_per_day);
    }
  }, [salaryType, workingScheduleId]);

  const daysList = [
    { key: "Sun", label: "Sun" },
    { key: "Mon", label: "Mon" },
    { key: "Tue", label: "Tue" },
    { key: "Wed", label: "Wed" },
    { key: "Thu", label: "Thu" },
    { key: "Fri", label: "Fri" },
    { key: "Sat", label: "Sat" },
  ];

  const [workingDays, setWorkingDays] = useState([]);

  useEffect(() => {
    if (!modalData?.working_schedule_id) {
      setWorkingDays([]);
      return;
    }

    const schedule = workingSchedules.find(
      (s) => String(s.id) === String(modalData.working_schedule_id),
    );

    if (schedule?.working_days) {
      try {
        const parsedDays =
          typeof schedule.working_days === "string"
            ? JSON.parse(schedule.working_days)
            : schedule.working_days;

        setWorkingDays(Array.isArray(parsedDays) ? parsedDays : []);
      } catch (err) {
        console.error("Invalid working_days format", err);
        setWorkingDays([]);
      }
    } else {
      setWorkingDays([]);
    }
  }, [modalData?.working_schedule_id, workingSchedules]);

  useEffect(() => {
    getUserRoles();
  }, []);

  const getStaffDetails = async () => {
    setLoading(true);
    try {
      const response = await staffDetails(id);

      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data.subjects) {
      const subject = JSON.parse(data.subjects);
      setSubjectIds(subject);
    }
  }, [data]);

  const getSubjects = async () => {
    setLoading(true);
    try {
      const response = await subjectList();

      if (response.data.status) {
        setSubjects(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getStaffId = async () => {
    setLoading(true);
    try {
      const response = await VerifyStaffId();

      if (response.data.status) {
        setStaffId(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateFetch();
      if (response.data) {
        setStates(response.data.states);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getDistrict = async (state = "") => {
    setLoading(true);
    try {
      const response = await DistrictFetch(state);
      if (response.data) {
        setDistricts(response.data.districts);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubjects();
    getState();
    getDistrict();
    getStaffDetails();
    getAppRoles();
    getAvailableMenus();
  }, []);

  useEffect(() => {
    // new array first, fall back to the legacy single role
    const roles =
      Array.isArray(data?.app_roles) && data.app_roles.length
        ? data.app_roles
        : data?.app_role
          ? [data.app_role]
          : [];

    setSelectedAppRoles(roles.map((r) => Number(r.id)));
  }, [data]);

  useEffect(() => {
    getStaffId();
  }, []);

  const handleMenuChange = (route) => {
    if (requiredMenuRoutes.includes(route)) {
      return;
    }

    setSelectedMenuRoutes((prev) =>
      prev.includes(route)
        ? prev.filter((item) => item !== route)
        : [...prev, route],
    );
  };

  const handleSelectAllGroupMenus = (group) => {
    const groupRoutes = (group.items || [])
      .map((item) => item.route)
      .filter(Boolean);

    const optionalRoutes = groupRoutes.filter(
      (route) => !requiredMenuRoutes.includes(route),
    );

    const allOptionalSelected =
      optionalRoutes.length > 0 &&
      optionalRoutes.every((route) => selectedMenuRoutes.includes(route));

    setSelectedMenuRoutes((prev) => {
      if (allOptionalSelected) {
        // Deselect optional menus, but retain mandatory menus
        return prev.filter((route) => !optionalRoutes.includes(route));
      }

      // Select every menu in this group
      return [...new Set([...prev, ...groupRoutes])];
    });
  };

  const getAvailableMenus = async () => {
    try {
      const response = await getAvailableStaffMenus();

      if (response?.data?.status) {
        const menuData = response?.data?.data || {};
        const groups = menuData.groups || [];
        const requiredRoutes = menuData.required_routes || [];

        setAvailableMenuGroups(Array.isArray(groups) ? groups : []);
        setRequiredMenuRoutes(
          Array.isArray(requiredRoutes) ? requiredRoutes : [],
        );
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to load staff menus.",
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  const updateStaff = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      formData.append("subjects", JSON.stringify(selectedSubjects));
      if (selectedAppRoles.length === 0) {
        formData.append("app_role_id", "");
      } else {
        selectedAppRoles.forEach((id) => formData.append("app_role_ids[]", id));
      }

      selectedMenuRoutes.forEach((route) => {
        formData.append("menu_routes[]", route);
      });
      const response = await StaffUpdates(formData);
      if (response?.data?.status) {
        navigate("/staffs");
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.subjects) {
      try {
        const ids = JSON.parse(data.subjects);
        setSelectedSubjects(ids);
      } catch (error) {
        console.log("Invalid subject format");
      }
    }
  }, [data]);

  const handleDayChange = (dayKey) => {
    setWorkingDays((prev) =>
      prev.includes(dayKey)
        ? prev.filter((d) => d !== dayKey)
        : [...prev, dayKey],
    );
  };

  useEffect(() => {
    if (!data || !data.id) {
      return;
    }

    // Extract previously selected routes from menu_group.
    const savedGroups = Array.isArray(data.menu_group) ? data.menu_group : [];

    const savedRoutes = savedGroups.flatMap((group) =>
      Array.isArray(group.items)
        ? group.items.map((item) => item.route).filter(Boolean)
        : [],
    );

    // Keep mandatory routes selected as well.
    setSelectedMenuRoutes([
      ...new Set([...savedRoutes, ...requiredMenuRoutes]),
    ]);
  }, [data, requiredMenuRoutes]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container-fluid mt-2">
              <StaffLayout />
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: 65,
                          height: 65,
                          background: "linear-gradient(135deg,#696cff,#8b5cf6)",
                          color: "#fff",
                          fontSize: "28px",
                        }}
                      >
                        <i className="ri-user-settings-line"></i>
                      </div>

                      <div className="ms-3">
                        <h3 className="fw-bold mb-1">Update Staff</h3>
                        <p className="text-muted mb-0">
                          {data?.name
                            ? `Editing profile for ${data.name}`
                            : "Update staff profile details."}
                        </p>
                      </div>
                    </div>

                    <Link to={"/staffs"} className="btn btn-outline-primary">
                      <i className="ri-arrow-left-line me-1"></i>
                      Back to Staff List
                    </Link>
                  </div>

                  <hr className="my-4" />

                  <form onSubmit={updateStaff} className="row g-4">
                    <input type="hidden" name="id" value={data?.id} />

                    {/* ---------------- BASIC DETAILS ---------------- */}
                    <div className="col-12">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 32,
                            height: 32,
                            background: "rgba(124, 58, 237, 0.1)",
                            color: "#7c3aed",
                            fontSize: 16,
                          }}
                        >
                          <i className="ri-user-3-line"></i>
                        </span>
                        <h5 className="m-0 fw-bold">Basic Details</h5>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="registration_no"
                          className="form-control"
                          placeholder="Registration No"
                          required
                          defaultValue={data?.registration_no || ""}
                          onChange={(e) => setReg(e.target.value)}
                        />
                        <label>
                          Registration No <span className="text-danger">*</span>
                        </label>
                        {regDetail?.staff && (
                          <div className="text-danger fs-10 mt-1">
                            <i className="ri-error-warning-line me-1"></i>
                            Registration already exists for{" "}
                            {regDetail.staff.name} (Reg No:{" "}
                            {regDetail.staff.registration_no})
                          </div>
                        )}
                        <span className="text-danger">
                          {error?.registration_no ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          className="form-control input-uppercase"
                          name="name"
                          id="name"
                          placeholder="Name"
                          required
                          defaultValue={data?.name}
                          onChange={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\b\w/g,
                              (c) => c.toUpperCase(),
                            ))
                          }
                        />
                        <label htmlFor="name">
                          Name <span className="text-danger">*</span>
                        </label>
                        <span className="text-danger">{error?.name ?? ""}</span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Mobile No"
                          name="mobile"
                          defaultValue={data?.mobile}
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                          }}
                        />
                        <label htmlFor="mobile">
                          Mobile No <span className="text-danger">*</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          defaultValue={data?.email}
                          name="email"
                        />
                        <label htmlFor="Email">Email</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <textarea
                          className="form-control input-uppercase"
                          name="father_name"
                          id="father_name"
                          placeholder="Father Name"
                          style={{ minHeight: "58px" }}
                          defaultValue={data?.father_name}
                          onChange={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\b\w/g,
                              (c) => c.toUpperCase(),
                            ))
                          }
                        ></textarea>
                        <label htmlFor="father_name">
                          Father Name <span className="text-danger">*</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline">
                        <select name="gender" className="form-select">
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            selected={data?.gender == "Male"}
                            value="Male"
                          >
                            Male
                          </option>
                          <option
                            selected={data?.gender == "Female"}
                            value="Female"
                          >
                            Female
                          </option>
                          <option
                            selected={data?.gender == "Other"}
                            value="Other"
                          >
                            Other
                          </option>
                        </select>
                        <label>Gender</label>
                        <span className="text-danger">
                          {error?.gender ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline">
                        <select name="category" className="form-select">
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            selected={data?.category == "General"}
                            value="General"
                          >
                            General
                          </option>
                          <option
                            selected={data?.category == "OBC"}
                            value="OBC"
                          >
                            OBC
                          </option>
                          <option selected={data?.category == "SC"} value="SC">
                            SC
                          </option>
                          <option selected={data?.category == "ST"} value="ST">
                            ST
                          </option>
                          <option
                            selected={data?.category == "EWS"}
                            value="EWS"
                          >
                            EWS
                          </option>
                        </select>
                        <label>Category</label>
                        <span className="text-danger">
                          {error?.category ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="date"
                          name="dob"
                          className="form-control"
                          defaultValue={data?.dob}
                        />
                        <label>Date of Birth</label>
                        <span className="text-danger">{error?.dob ?? ""}</span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="referred_by"
                          className="form-control"
                          placeholder="Referred By"
                          defaultValue={data?.referred_by}
                        />
                        <label>Referred By</label>
                        <span className="text-danger">
                          {error?.referred_by ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-3 border rounded-3 p-3 h-100">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: 44,
                            height: 44,
                            background: "rgba(124, 58, 237, 0.08)",
                            color: "#7c3aed",
                          }}
                        >
                          <i className="ri-image-add-line fs-4"></i>
                        </span>
                        <div className="flex-grow-1">
                          <label className="form-label small fw-semibold mb-1 d-block">
                            Profile Image
                          </label>
                          {data?.img && (
                            <a
                              href={data.img}
                              target="_blank"
                              rel="noreferrer"
                              className="d-block small mb-1 text-decoration-none"
                            >
                              <i className="ri-external-link-line me-1"></i>
                              View current
                            </a>
                          )}
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="img"
                            name="img"
                            accept="image/*"
                            capture="environment"
                          />
                        </div>
                      </div>
                    </div>

                    {/* ---------------- ADDRESS ---------------- */}
                    <div className="col-12">
                      <hr />
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 32,
                            height: 32,
                            background: "rgba(124, 58, 237, 0.1)",
                            color: "#7c3aed",
                            fontSize: 16,
                          }}
                        >
                          <i className="ri-map-pin-line"></i>
                        </span>
                        <h5 className="m-0 fw-bold">Address</h5>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="village"
                          className="form-control input-uppercase"
                          placeholder="Village"
                          defaultValue={data?.village}
                        />
                        <label>Village</label>
                        <span className="text-danger">
                          {error?.village ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          className="form-select"
                          name="state"
                          onChange={(e) => {
                            getDistrict(e.target.value);
                          }}
                        >
                          <option selected disabled>
                            Select State
                          </option>
                          {states?.map((state) => (
                            <option
                              key={state.id}
                              value={state.name}
                              selected={state.name == data?.state}
                            >
                              {state.name}
                            </option>
                          ))}
                        </select>
                        <label>State</label>
                        <span className="text-danger">
                          {error?.state ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select className="form-select" name="district">
                          <option selected disabled>
                            Select District
                          </option>
                          {districts?.map((district) => (
                            <option
                              key={district.id}
                              value={district.name}
                              selected={district.name == data?.district}
                            >
                              {district.name}
                            </option>
                          ))}
                        </select>
                        <label>District</label>
                        <span className="text-danger">
                          {error?.district ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="pincode"
                          className="form-control"
                          placeholder="Pin Code"
                          minLength={6}
                          maxLength={6}
                          defaultValue={data?.pincode}
                        />
                        <label>Pin Code</label>
                        <span className="text-danger">
                          {error?.pincode ?? ""}
                        </span>
                      </div>
                    </div>

                    {/* ---------------- EXPERIENCE ---------------- */}
                    <div className="col-12">
                      <hr />
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 32,
                            height: 32,
                            background: "rgba(124, 58, 237, 0.1)",
                            color: "#7c3aed",
                            fontSize: 16,
                          }}
                        >
                          <i className="ri-briefcase-4-line"></i>
                        </span>
                        <h5 className="m-0 fw-bold">Experience</h5>
                      </div>
                      <p className="text-muted small mb-3 ms-1">
                        Previous work / education background (optional)
                      </p>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <textarea
                          name="last_education"
                          className="form-control"
                          placeholder="Education"
                          style={{ minHeight: "58px" }}
                          defaultValue={data?.last_education}
                        ></textarea>
                        <label>Last Education</label>
                        <span className="text-danger">
                          {error?.education ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="last_school"
                          className="form-control input-uppercase"
                          placeholder="School"
                          defaultValue={data?.last_school}
                          onChange={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\b\w/g,
                              (c) => c.toUpperCase(),
                            ))
                          }
                        />
                        <label>Last School / Institute</label>
                        <span className="text-danger">
                          {error?.school ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="last_designation"
                          className="form-control input-uppercase"
                          placeholder="Last Designation"
                          defaultValue={data?.last_designation}
                          onChange={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\b\w/g,
                              (c) => c.toUpperCase(),
                            ))
                          }
                        />
                        <label>Last Designation</label>
                        <span className="text-danger">
                          {error?.last_designation ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="text"
                          name="last_company"
                          className="form-control input-uppercase"
                          placeholder="Last Company"
                          defaultValue={data?.last_company}
                          onChange={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\b\w/g,
                              (c) => c.toUpperCase(),
                            ))
                          }
                        />
                        <label>Last Company</label>
                        <span className="text-danger">
                          {error?.last_company ?? ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-3 border rounded-3 p-3 h-100">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: 44,
                            height: 44,
                            background: "rgba(124, 58, 237, 0.08)",
                            color: "#7c3aed",
                          }}
                        >
                          <i className="ri-file-text-line fs-4"></i>
                        </span>
                        <div className="flex-grow-1">
                          <label
                            htmlFor="resume"
                            className="form-label small fw-semibold mb-1 d-block"
                          >
                            Resume (PDF/DOC)
                          </label>
                          {data?.resume && (
                            <a
                              href={data.resume}
                              target="_blank"
                              rel="noreferrer"
                              className="d-block small mb-1 text-decoration-none"
                            >
                              <i className="ri-external-link-line me-1"></i>
                              View current
                            </a>
                          )}
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="resume"
                            name="resume"
                            accept=".pdf,.doc,.docx"
                          />
                          <span className="text-danger small">
                            {error?.resume ?? ""}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* ---------------- ROLE / ACCESS ---------------- */}
                    <div className="col-12">
                      <hr />
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <span
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 32,
                            height: 32,
                            background: "rgba(124, 58, 237, 0.1)",
                            color: "#7c3aed",
                            fontSize: 16,
                          }}
                        >
                          <i className="ri-shield-user-line"></i>
                        </span>
                        <h5 className="m-0 fw-bold">Role / Access Details</h5>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          name="staff_type"
                          className="form-select"
                          required
                          value={staffType}
                          onChange={(e) => setStaffType(e.target.value)}
                        >
                          <option value="">Select Type</option>
                          <option value="Teaching">Teaching staff</option>
                          <option value="Administrative">
                            Administrative staff
                          </option>
                          <option value="Other">Other staff</option>
                        </select>
                        <label>
                          Staff Type <span className="text-danger">*</span>
                        </label>
                        <span className="text-danger">
                          {error?.type_id ?? ""}
                        </span>
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          name="role_id"
                          id="role_id"
                          className="form-select"
                        >
                          <option value="" selected disabled>
                            Select Role
                          </option>

                          <option value="">No Role / Remove Access</option>


                          {roles?.map((role, i) => (
                            <option
                              key={i}
                              value={role?.id}
                              selected={role.id === data?.role_id && true}
                            >
                              {role?.name}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="role_id">Staff Access/Role</label>
                      </div>
                    </div> */}
                    {isSuperAdmin && (
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline">
                          <select
                            name="role_id"
                            id="role_id"
                            className="form-select"
                            value={data?.role_id == 1 ? "1" : ""}
                            onChange={(e) =>
                              setData((prev) => ({
                                ...prev,
                                role_id: e.target.value,
                              }))
                            }
                          >
                            <option value="">No Role / Remove Access</option>
                            <option value="1">Super Admin</option>
                          </select>

                          <label htmlFor="role_id">Staff Access/Role</label>
                        </div>
                      </div>
                    )}

                    <div className="col-12">
                      <div className="border rounded-3 p-3">
                        <label className="fw-semibold mb-2 d-flex align-items-center gap-1">
                          <i className="ri-shield-user-line text-primary"></i>
                          App Roles
                          <span className="text-muted small fw-normal ms-1">
                            (select one or more, or none)
                          </span>
                        </label>

                        <div className="d-flex flex-wrap gap-2">
                          {appRoles?.map((role) => {
                            const checked = selectedAppRoles.includes(
                              Number(role.id),
                            );
                            return (
                              <label
                                key={role.id}
                                htmlFor={`app-role-${role.id}`}
                                className="d-flex align-items-center gap-2 border rounded-2 px-3 py-2 m-0"
                                style={{
                                  minWidth: 160,
                                  cursor: "pointer",
                                  background: checked
                                    ? "rgba(124, 58, 237, 0.06)"
                                    : "transparent",
                                  borderColor: checked ? "#7c3aed" : undefined,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="form-check-input m-0 flex-shrink-0"
                                  id={`app-role-${role.id}`}
                                  checked={checked}
                                  onChange={() => handleAppRoleChange(role.id)}
                                />
                                <span className="flex-grow-1">{role.name}</span>
                              </label>
                            );
                          })}
                        </div>

                        <span className="text-danger">
                          {error?.app_role_ids ?? ""}
                        </span>
                      </div>
                    </div>

                    {/* ---------------- MOBILE MENU ACCESS ---------------- */}
                    <div className="col-12">
                      <div className="border rounded-3 p-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                          <label className="fw-semibold d-flex align-items-center gap-2 mb-0">
                            <i className="ri-smartphone-line text-primary fs-5"></i>
                            Mobile App Menu Access
                          </label>

                          <span className="badge bg-label-primary">
                            {selectedMenuRoutes.length} selected
                          </span>
                        </div>

                        <p className="text-muted small mb-3">
                          Select the screens this staff member can access in the
                          mobile app. Mandatory menus cannot be disabled.
                        </p>

                        {availableMenuGroups.length === 0 ? (
                          <div className="text-muted small">
                            No menu groups available.
                          </div>
                        ) : (
                          availableMenuGroups.map((group, groupIndex) => (
                            <div
                              className="mb-4"
                              key={group.id ?? group.name ?? groupIndex}
                            >
                              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                                <div className="fw-semibold">
                                  {group.title ??
                                    group.name ??
                                    group.label ??
                                    "Menus"}
                                </div>

                                {(() => {
                                  const groupRoutes = (group.items || [])
                                    .map((item) => item.route)
                                    .filter(Boolean);

                                  const optionalRoutes = groupRoutes.filter(
                                    (route) =>
                                      !requiredMenuRoutes.includes(route),
                                  );

                                  const allSelected =
                                    groupRoutes.length > 0 &&
                                    groupRoutes.every((route) =>
                                      selectedMenuRoutes.includes(route),
                                    );

                                  return (
                                    <div className="form-check mb-0">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`select-all-menu-group-${group.id ?? groupIndex}`}
                                        checked={allSelected}
                                        disabled={optionalRoutes.length === 0}
                                        onChange={() =>
                                          handleSelectAllGroupMenus(group)
                                        }
                                      />

                                      <label
                                        className="form-check-label small fw-semibold"
                                        htmlFor={`select-all-menu-group-${group.id ?? groupIndex}`}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Select All
                                      </label>
                                    </div>
                                  );
                                })()}
                              </div>

                              <div className="row g-2">
                                {(group.items || []).map((item) => {
                                  const route = item.route;
                                  if (!route) return null;

                                  const required =
                                    requiredMenuRoutes.includes(route);
                                  const checked =
                                    selectedMenuRoutes.includes(route);

                                  return (
                                    <div
                                      className="col-md-4 col-sm-6"
                                      key={route}
                                    >
                                      <label
                                        htmlFor={`staff-menu-${route}`}
                                        className="d-flex align-items-center gap-2 border rounded-2 p-3 h-100"
                                        style={{
                                          cursor: required
                                            ? "not-allowed"
                                            : "pointer",
                                          background: checked
                                            ? "rgba(124, 58, 237, 0.06)"
                                            : "transparent",
                                          borderColor: checked
                                            ? "#7c3aed"
                                            : undefined,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input m-0 flex-shrink-0"
                                          id={`staff-menu-${route}`}
                                          checked={checked}
                                          disabled={required}
                                          onChange={() =>
                                            handleMenuChange(route)
                                          }
                                        />

                                        <span className="flex-grow-1">
                                          {item.title ?? item.name ?? route}

                                          {required && (
                                            <span className="d-block text-muted small">
                                              Mandatory
                                            </span>
                                          )}
                                        </span>
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>

                    {/* subjects - now correctly visible + pre-checked on load
                        for Teaching staff, since staffType is synced from data */}
                    {staffType == "Teaching" && (
                      <div className="col-12">
                        <div className="border rounded-3 p-3">
                          <label className="fw-semibold mb-2 d-flex align-items-center gap-1">
                            <i className="ri-book-open-line text-primary"></i>
                            Subjects <span className="text-danger">*</span>
                          </label>
                          <div className="d-flex flex-wrap gap-2">
                            {subjects?.map((subject, i) => {
                              const checked = selectedSubjects.includes(
                                subject.id,
                              );
                              return (
                                <label
                                  key={i}
                                  htmlFor={`subject-${subject.id}`}
                                  className="d-flex align-items-center gap-2 border rounded-2 px-3 py-2 m-0"
                                  style={{
                                    minWidth: 160,
                                    cursor: "pointer",
                                    background: checked
                                      ? "rgba(124, 58, 237, 0.06)"
                                      : "transparent",
                                    borderColor: checked
                                      ? "#7c3aed"
                                      : undefined,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    className="form-check-input m-0 flex-shrink-0"
                                    id={`subject-${subject.id}`}
                                    value={subject.id}
                                    checked={checked}
                                    onChange={() =>
                                      handleSubjectChange(subject.id)
                                    }
                                  />
                                  <span className="flex-grow-1">
                                    {subject.name}
                                  </span>
                                </label>
                              );
                            })}
                          </div>
                          <span className="text-danger">
                            {error?.subjects ?? ""}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="col-12 mt-3 text-end">
                      <button
                        type="submit"
                        className="btn btn-primary px-5 py-2"
                      >
                        <i className="ri-save-line me-1"></i>
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
